import { NewNameType } from "../../types/commonTypes/newNameType";

export const initialNewNameState : NewNameType ={
    additionalName: "",
    fullName: ""
}